import { render, staticRenderFns } from "./ButtonAppPorting.vue?vue&type=template&id=6272c40f&scoped=true"
import script from "./ButtonAppPorting.vue?vue&type=script&lang=js"
export * from "./ButtonAppPorting.vue?vue&type=script&lang=js"
import style0 from "./ButtonAppPorting.vue?vue&type=style&index=0&id=6272c40f&prod&lang=stylus&scoped=true"
import style1 from "./ButtonAppPorting.vue?vue&type=style&index=1&id=6272c40f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272c40f",
  null
  
)

export default component.exports